import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './header.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [HeaderComponent],
    imports: [RouterModule, CommonModule, TranslateModule],
    exports: [HeaderComponent],
})
export class HeaderModule {}
